import { GET_DEAL_SHEET_CONFIGURATION } from './getConfiguration';
import { GET_DEAL_SHEET_CONFIGURATIONS } from './getConfigurations';
import { GET_DEAL_SHEET_GLOBAL_CONFIGURATION } from './getGlobalConfiguration';
import { GET_DEAL_SHEET_TABLE_CONFIGURATIONS } from './getTableListConfigurations';
import { GET_DEAL_SHEET_TABLE_GLOBAL_CONFIGURATIONS } from './getTableListGlobalConfigurations';

import { CREATE_DEAL_SHEET_CONFIGURATION } from './createConfiguration';
import { UPDATE_DEAL_SHEET_CONFIGURATION } from './updateConfiguration';
import { DELETE_DEAL_SHEET_CONFIGURATION } from './deleteConfiguration';

export const dealSheetConfigurationApi = {
  getConfig: GET_DEAL_SHEET_CONFIGURATION,
  getGlobalConfig: GET_DEAL_SHEET_GLOBAL_CONFIGURATION,
  getConfigs: GET_DEAL_SHEET_CONFIGURATIONS,
  getTableConfigs: GET_DEAL_SHEET_TABLE_CONFIGURATIONS,
  getTableGlobalConfig: GET_DEAL_SHEET_TABLE_GLOBAL_CONFIGURATIONS,

  createConfig: CREATE_DEAL_SHEET_CONFIGURATION,
  updateConfig: UPDATE_DEAL_SHEET_CONFIGURATION,
  deleteConfig: DELETE_DEAL_SHEET_CONFIGURATION,
};

export * from './useDealSheetConfiguration';
